export class DividerUtils {
	static enforceDividerRules(list: any[]): any {
		let dividerCheck: (item) => boolean = (listItem): boolean => {
			return listItem?.divider;
		};
		return list.preventFirst(dividerCheck).preventLast(dividerCheck).preventConsecutive(dividerCheck);
	}
}
